export const { jQuery } = window;
export const $ = jQuery;
